/** Web Share API (files) — email, WhatsApp, etc. on supported mobile browsers. */
export function canNativeShareFile(file: File): boolean {
  return (
    typeof navigator !== 'undefined' &&
    typeof navigator.share === 'function' &&
    typeof navigator.canShare === 'function' &&
    navigator.canShare({ files: [file] })
  );
}

export async function shareFileNative(file: File): Promise<void> {
  if (!canNativeShareFile(file)) {
    throw new Error('Sharing is not supported for this file on this device');
  }
  await navigator.share({ files: [file] });
}
